export default __webpack_public_path__ + "static/media/2016.be61bcb5.png";